<template>
  <div class="flex min-w-0 flex-1 items-center">
    <span
      v-tooltip.bottom="{ value: greeting_tooltip, escape: false }"
      class="inline-flex min-w-0 cursor-help items-center gap-2 truncate font-semibold text-neutral-900"
      data-test="navbar-secondary-greeting"
    >
      <span class="truncate">{{ greeting }}</span>
      <span
        aria-hidden="true"
        class="shrink-0 text-base"
      >
        {{ greeting_emoji }}
      </span>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { formatWithLocale, getTimeBasedGreeting } from '@/app/util/date_fns';

const { t } = useI18n();
const store = useStore();

const current_profile = computed(() => store.getters.current_profile);

const greeting = computed(() =>
  t(`dashboard.greetings.${getTimeBasedGreeting()}`, {
    first_name: current_profile.value.attributes.first_name,
  }),
);

const greeting_emoji = computed(() => (getTimeBasedGreeting() === 'night' ? '🌙' : '👋'));

const greeting_tooltip = computed(() => `<span>${formatWithLocale(new Date(), 'EEEE, d MMMM yyyy')}</span>`);
</script>
